import { createApp, nextTick } from 'vue'
import './index.css'

declare global {
  interface Window {
    __PRERENDER_READY__?: boolean
  }
}

import PrimeVue from 'primevue/config'
import Aura from '@primeuix/themes/aura'
import { definePreset } from '@primeuix/themes'
import 'primeicons/primeicons.css'

import App from '@/App.vue'
import { useTheme } from '@/composables/useTheme'

const preset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#faf7f2',
      100: '#f1ead9',
      200: '#e4d7bc',
      300: '#d3c19f',
      400: '#c1ae8c',
      500: '#ad9670',
      600: '#927c5c',
      700: '#6e5d46',
      800: '#4f4334',
      900: '#322a20',
      950: '#1c1812'
    },
    secondary: {
      50: '#faf7f2',
      100: '#f1ead9',
      200: '#e4d7bc',
      300: '#d3c19f',
      400: '#c1ae8c',
      500: '#ad9670',
      600: '#927c5c',
      700: '#6e5d46',
      800: '#4f4334',
      900: '#322a20',
      950: '#1c1812'
    }
  }
})

useTheme().init()

const app = createApp(App)

app.use(PrimeVue, {
  theme: {
    preset,
    options: {
      darkModeSelector: '.dark'
    }
  }
})

app.mount('#app')

nextTick(() => {
  window.__PRERENDER_READY__ = true
})
